import store from 'store'
import vueStore from '../store'
import * as turf from '@turf/turf'
import i18n from '../i18n'

function Rad (d) {
  return d * Math.PI / 180.0 // 经纬度转换成三角函数中度分表形式。
}

// 计算距离单位为公里，参数分别为第一点的纬度，经度；第二点的纬度，经度
export function GetDistance (lat1, lng1, lat2, lng2) {
  const radLat1 = Rad(lat1)
  const radLat2 = Rad(lat2)
  const a = radLat1 - radLat2
  const b = Rad(lng1) - Rad(lng2)
  let s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a / 2), 2) + Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)))
  s = Math.round(s * 6378137)
  console.log(s)
  if (s < 1000) {
    s = Math.round(s / 100) * 100 + i18n.t('common.metre')
  } else {
    s = Math.round(s / 100) / 10 + i18n.t('common.kilometre')
  }

  return s
}


//计算距离单位为米，参数分别为第一点的纬度，经度；第二点的纬度，经度
export function calcDistance (lat1, lng1, lat2, lng2) {
  const radLat1 = Rad(lat1)
  const radLat2 = Rad(lat2)
  const a = radLat1 - radLat2
  const b = Rad(lng1) - Rad(lng2)
  let s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a / 2), 2) + Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)))
  s = Math.round(s * 6378137)
  
  return s
}

export const storeWithExpiration = {
  set: function (key, val, exp) {
    // unit of exp is ms
    store.set(key, { val: val, exp: exp, time: new Date().getTime() })
  },
  get: function (key) {
    var info = store.get(key)
    if (!info) { return {} }
    if (new Date().getTime() - info.time > info.exp) {
      return null
    }
    return info.val
  }
}

export function formatMinutes (minutes) {
  const days = Math.floor(minutes / 1440)
  const hours = Math.floor((minutes - days * 1440) / 60)
  const mins = minutes % 60
  let string = ''
  if (days > 0) {
    if (i18n.locale === 'en') {
      string += `${days} ${i18n.t('common.day')}`
      if (days > 1) string += 's'
    } else {
      string += days + i18n.t('common.day')
    }
  }
  if (hours > 0) {
    if (i18n.locale === 'en') {
      string += `${hours} ${i18n.t('common.hour')}`
      if (hours > 1) string += 's'
    } else {
      string += hours + i18n.t('common.hour')
    }
  }
  if (days === 0 && hours === 0 && mins > 0) {
    if (i18n.locale === 'en') {
      string += `${mins} ${i18n.t('common.minute')}`
      if (mins > 1) string += 's'
    } else {
      string += mins + i18n.t('common.minute')
    }
  } else if (mins > 0) {
    if (i18n.locale === 'en') {
      string += `${mins} ${i18n.t('common.min')}`
      if (mins > 1) string += 's'
    } else {
      string += mins + i18n.t('common.min')
    }
  }
  return string
}

export function pointWithinThere (longitude, latitude) {
  let searchArray = []
  const id = vueStore.state.siteId || '1'
  console.log(id)
  if (id === '129') { // 新加坡
    searchArray = [
      [103.588115, 1.217880],
      [103.718142, 1.460282],
      [103.806480, 1.479438],
      [104.074113, 1.432449],
      [104.095169, 1.395011],
      [104.021168, 1.243154],
      [103.736118, 1.158800],
      [103.591934, 1.201537],
      [103.588115, 1.217880]
    ]
  } else if (id === '33') {
    searchArray = [
      [5.990063, 54.872305],
      [15.347359, 54.981720],
      [14.334313, 47.357822],
      [6.275174, 47.532519],
      [5.990063, 54.872305]
    ]
  } else if (id === '1') { // 圣淘沙
    searchArray = [
      [103.819852, 1.265713],
      [103.819691, 1.260715],
      [103.805111, 1.260704],
      [103.804682, 1.236098],
      [103.852152, 1.236357],
      [103.851047, 1.267034],
      [103.819852, 1.265713]
    ]
  } else { // RWS
    searchArray = [
      [103.814717, 1.258795],
      [103.817741, 1.260959],
      [103.826527, 1.253544],
      [103.824172, 1.251230],
      [103.814717, 1.258795]
    ]
  }
  const points = turf.points([
    // [103.826649, 1.24865]
    [longitude, latitude]
  ])

  const searchWithin = turf.polygon([searchArray])

  const ptsWithin = turf.pointsWithinPolygon(points, searchWithin)
  return ptsWithin.features.length > 0
}

export function formatSeconds (seconds) {
  const hours = Math.floor(seconds / 3600)
  const mins = Math.floor((seconds - hours * 3600) / 60)
  const secs = seconds % 60

  let string = ''
  if (hours > 0) {
    string += hours + i18n.t('common.hour')
  }
  if (mins > 0) {
    string += hours > 0 ? `<br>${mins}${i18n.t('common.min')}` : mins + i18n.t('common.min')
  }
  if (secs > 0) {
    string += hours > 0 || mins > 0 ? `<br>${secs}${i18n.t('common.second')}` : secs +  i18n.t('common.second')
  }
  return string
}

/**
 * 点到线的最短距离实际上就是点到线的垂直距离。
 * (x,y)为点的坐标
 * (x1,y1)为线段上点的坐标
 * (x2,y2)为线段另外一点的坐标
 */
export function distanceOfPoint2Line(pointLng, pointLat, lineStartLng, lineStartLat, lineEndLng, lineEndLat) {
  let xx = lineStartLat - lineEndLat
  let yy = lineStartLng - lineEndLng
  let distance = ((xx * (pointLat - lineEndLat)) + (yy * (pointLng - lineEndLng))) / ((xx * xx) + (yy * yy))
  let lat4 = lineEndLat + xx * distance
  let lng4 = lineEndLng + yy * distance
  // console.log('计算出来的经纬度', lng4, lat4)
  const distanceStart = calcDistance(lineStartLat, lineStartLng, pointLat, pointLng)
  const distanceEnd = calcDistance(lineEndLat, lineEndLng, pointLat, pointLng)
  // console.log('距离起点距离', distanceStart, '距离终点距离', distanceEnd)
  if (lat4 > Math.min(lineStartLat, lineEndLat) && lat4 < Math.max(lineStartLat, lineEndLat) && lng4 > Math.min(lineStartLng, lineEndLng) && lng4 < Math.max(lineStartLng, lineEndLng)) {
    return {
      distance: calcDistance(lat4, lng4, pointLat, pointLng),
      lng: lng4,
      lat: lat4
    }
  } else {
    // console.log(distanceStart, distanceEnd)
    if (distanceStart < distanceEnd) {
      return {
        distance: distanceStart,
        lng: lineStartLng,
        lat: lineStartLat
      }
    } else {
      return {
        distance: distanceEnd,
        lng: lineEndLng,
        lat: lineEndLat
      }
    }
  }
}